import { Text } from '@/shared/ui/primitives';
import { History } from 'lucide-react';
import type { FC } from 'react';

import styles from './ActionLogEmpty.module.css';

interface ActionLogEmptyProps {
  hint?: string;
}

export const ActionLogEmpty: FC<ActionLogEmptyProps> = ({ hint = 'No history yet' }) => {
  return (
    <div className={styles.empty}>
      <History size={32} strokeWidth={1.5} />
      <Text variant="subheadline">{hint}</Text>
    </div>
  );
};
